import dynamic from "next/dynamic";

export const DynamicContent002 = dynamic(() => import("./Content002"), {
  suspense: true,
});
